module.exports = __webpack_public_path__ + "static/media/nav-icon-help.9d188786.svg";